export default {
	notification_health: 'දැනුම්දීම් සෞඛ්‍යය',
	notification_health_summary: 'සාරාංශය',
	notification_health_loading: 'දැනුම්දීම් සෞඛ්‍යය පරීක්ෂා කරමින්...',
	notification_health_refresh: 'නැවුම් කරන්න',
	notification_health_fix: 'කළ යුතු දේ',
	notification_health_unavailable: 'දැනුම්දීම් සෞඛ්‍යය පූරණය කළ නොහැකි විය',
	notification_health_healthy: 'සෞඛ්‍ය සම්පන්න',
	notification_health_blocked: 'අවහිර කර ඇත',
	notification_health_degraded: 'අවධානය අවශ්‍යයි',
	notification_health_no_app_user: 'යෙදුම් පිවිසීමක් නැත',
	notification_health_unknown: 'නොදනී',
	notification_health_app_version: 'යෙදුම් අනුවාදය',
	notification_health_last_delivery: 'අවසාන බෙදාහැරීම',
	notification_health_time_just_now: 'මේ දැන්',
	notification_health_time_minutes: 'මිනිත්තු {count}කට පෙර',
	notification_health_time_hours: 'පැය {count}කට පෙර',
	notification_health_time_days: 'දින {count}කට පෙර',
	notification_health_time_unknown: 'නොදනී',
	notification_health_summary_healthy: 'දැනුම්දීම් ක්‍රියා කළ යුතුය',
	notification_health_summary_no_app_user: 'පිරිසිදු කරන අය ජංගම යෙදුමට පිවිස නැත',
	notification_health_summary_blocked_no_token: 'Push ටෝකනය නැත — පිරිසිදු කරන අය යෙදුම විවෘත කර පිවිසිය යුතුය',
	notification_health_summary_blocked_off: 'යෙදුමේ දැනුම්දීම් අක්‍රියයි',
	notification_health_check_portal_contact_label: 'පෝටල් සම්බන්ධතාව ඇත',
	notification_health_check_portal_active_label: 'සම්බන්ධතාව සක්‍රියයි',
	notification_health_check_portal_rooms_label: 'කාමර පවරා ඇත',
	notification_health_check_portal_shifts_label: 'වැඩ වාර පවරා ඇත',
	notification_health_check_app_user_label: 'ජංගම යෙදුමට පිවිස ඇත',
	notification_health_check_push_token_label: 'Push ටෝකනය ලියාපදිංචි කර ඇත',
	notification_health_check_notification_mode_label: 'දැනුම්දීම් ප්‍රකාරය',
	notification_health_check_time_schedule_label: 'දැනුම්දීම් කාල තොරතුරු තුළ',
	notification_health_check_ios_geo_filter_label: 'iOS ස්ථාන පෙරහන',
	notification_health_check_recent_push_attempt_label: 'මෑත push උත්සාහය (48ප)',
	notification_health_check_last_push_ignored_label: 'අවසාන සංඥාව යවා නැත',
	notification_health_check_recent_push_delivered_label: 'මෑත push බෙදාහැරීම (48ප)',
	notification_health_detail_portal_contact_found: 'පෝටලයේ හමු විය',
	notification_health_detail_portal_contact_missing: 'සම්බන්ධතා වාර්තාව හමු නොවීය',
	notification_health_detail_portal_active_active: 'සක්‍රිය',
	notification_health_detail_portal_active_inactive: 'අක්‍රිය',
	notification_health_detail_portal_rooms_assigned: 'කාමර {count}',
	notification_health_detail_portal_rooms_none: 'කාමර පවරා නැත',
	notification_health_detail_portal_shifts_assigned: 'වැඩ වාර {count}',
	notification_health_detail_portal_shifts_none: 'වැඩ වාර පවරා නැත',
	notification_health_detail_app_user_logged_in: 'යෙදුම් අනුවාදය {version}, අවසාන සමමුහුර්තය {lastSync}',
	notification_health_detail_app_user_never: 'කිසිදා පිවිස නැත',
	notification_health_detail_push_token_present: 'FCM ටෝකනය ඇත',
	notification_health_detail_push_token_empty: 'ටෝකනය හිස්',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'වත්මන් වේලාව කාලසටහන තුළ',
	notification_health_detail_time_schedule_outside: 'වත්මන් වේලාව වින්‍යාස කළ කාලසටහනෙන් පිටත',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'පසුගිය පැය 48 තුළ push උත්සාහ නැත',
	notification_health_detail_last_push_ignored: 'අවසාන push ඉල්ලීම නොසලකා හරින ලදී (servik වැඩ ප්‍රදේශය සඳහා වින්‍යාස නොකර ඇත)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'පසුගිය පැය 48 තුළ සාර්ථක බෙදාහැරීම් නැත',
	notification_health_fix_portal_contact: 'පරිශීලක පැනලයේ මෙම පිරිසිදු කරන අය සාදන්න',
	notification_health_fix_portal_active: 'මෙම පිරිසිදු කරන අය සඳහා සක්‍රිය ටොගලය සක්‍රිය කරන්න',
	notification_health_fix_portal_rooms: 'මෙම පිරිසිදු කරන අයට අවම වශයෙන් කාමරයක් පවරන්න',
	notification_health_fix_portal_shifts: 'අවම වශයෙන් වැඩ වාරයක් පවරන්න',
	notification_health_fix_app_user: 'පිරිසිදු කරන අය යෙදුම ස්ථාපනය කර මෙම දුරකථන අංකයෙන් පිවිසිය යුතුය',
	notification_health_fix_push_token: 'පිරිසිදු කරන අයට යෙදුම විවෘත කර iOS සැකසුම්වල දැනුම්දීම් අනුමත කර නැවත පිවිසෙන්නැයි කියන්න',
	notification_health_fix_notification_mode: 'යෙදුමේ දැනුම්දීම් ප්‍රකාරය අක්‍රිය සිට සැමවිටම වෙත වෙනස් කරන්න',
	notification_health_fix_time_schedule: 'සැලසුම් කළ කාල තොරතුරු දක්වා රැඳී සිටින්න හෝ ප්‍රකාරය සැමවිටම වෙත වෙනස් කරන්න',
	notification_health_fix_ios_geo_filter: 'පිරිසිදු කරන අය දැනුම්දීම් කලාපයෙන් පිටත — අඩවියේ යෙදුම විවෘත කරන ලෙස කියන්න',
	notification_health_fix_last_push_ignored: 'සංඥාව ඇති කළ කාමරයේ වැඩ ප්‍රදේශ servik වින්‍යාසය පරීක්ෂා කරන්න',
	notification_health_fix_recent_push_delivered_filters: 'දැනුම්දීම් පෙරහන් හෝ උපකරණ සැකසුම් පරීක්ෂා කරන්න',
	notification_health_fix_recent_push_delivered_token: 'පළමුව push ටෝකනය ලියාපදිංචි කරන්න',
	notification_health_mode_on: 'සැමවිටම',
	notification_health_mode_off: 'අක්‍රිය',
	notification_health_mode_time: 'කාල අනුව',
	notification_health_mode_location: 'ස්ථාන අනුව',
	notification_health_filter_on: 'සක්‍රිය',
	notification_health_filter_off: 'අක්‍රිය',
};
